<template>
  <div id="DlgCartHesab">
    <card>
      <template v-slot:header></template>
      <template v-slot:content>
        <DetailUser>
          <template v-slot:Pnl-r1>
            <h1 class="border-left"><i class="fad fa-user font-size-icon" style="font-size: 30px" title="مشخصات کاربر"></i></h1>
          </template>
          <template v-slot:Pnl-r2>
            <span>شماره مشتری : </span>
            <span class="font-weight-bold text-logo" dir="rtl"> {{ AzaInfo.ShomareOzv }}</span>
          </template>
          <template v-slot:Pnl-r3>
            <span>مشخصات : </span>
            <span class="font-weight-bold text-logo" dir="rtl">{{ AzaInfo.OzvName }} {{ AzaInfo.OzvFamily }}</span>
          </template>
          <template v-slot:Pnl-r4>
            <span>کد ملی : </span>
            <span class="font-weight-bold text-logo" dir="rtl">{{ AzaInfo.CodeMeli == null || AzaInfo.CodeMeli == '' ? '[ ثبت نشده ]' : AzaInfo.CodeMeli }}</span>
          </template>
        </DetailUser>
        <div class="row mt-3">
          <div id="ShomareOzv" class="col-md-2 col-12 mt-2">
            <small>کد مشتری</small>
            <input type="text" :disabled="AzaInfo.ShomareOzv" :placeholder="$session.get('UserInfo').codeShobe.trim() + '-'" class="form-control" v-model="DataAxiosDlgCartHesab.ArryfildValue.ShomareOzv" dir="ltr" />
          </div>
          <div id="Vcode" class="col-md-2 col-12 mt-2">
            <small>ش حسـاب/تسهـیلات</small>
            <input type="text" :disabled="Vcode" :placeholder="$session.get('UserInfo').codeShobe.trim() + '-'" class="form-control" v-model="DataAxiosDlgCartHesab.ArryfildValue.Vcode" dir="ltr" />
          </div>
          <div id="Vcode" class="col-md-2 col-12 mt-2">
            <small>دوره مالی </small>
            <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="ValueResultDoreMali" :rownumintable="3" :action="'TblCombo/GetDoreMali'" :method="'POST'" :idinput="'GetDoreMali'" :keyItem="'GetDoreMali'" :queryString="{ id: $session.get('UserInfo').tblShobeId }"> </SearchableCombo>
          </div>
          <div id="TarixSanadAz" class="col-md-2 col-12 mt-2">
            <small>تاریخ سند از</small>
            <date-picker editable v-model="DataAxiosDlgCartHesab.ArryfildValue.TarixSanadAz" color="#f38905"> </date-picker>
            <input type="text" id="TarixSanadAz" class="d-none InputText" dir="ltr" v-model="DataAxiosDlgCartHesab.ArryfildValue.TarixSanadAz" />
          </div>
          <div id="TarixSanadTa" class="col-md-2 col-12 mt-2">
            <small>تاریخ سند تا</small>
            <date-picker editable v-model="DataAxiosDlgCartHesab.ArryfildValue.TarixSanadTa" color="#2A3F54"> </date-picker>
            <input type="text" id="TarixSanadTa" class="d-none InputText" dir="ltr" v-model="DataAxiosDlgCartHesab.ArryfildValue.TarixSanadTa" />
          </div>
          <div  class="col-md-2 col-12 mt-3">
            <button class="btn btn-success m-1 float-left mt-3 w-100" dir="ltr" @click="Search">جستجــو<i class="fa fa-search ml-2"></i></button>
          </div>
        </div>
        
        <Bnp-Grid :Sortable="true" :action="false" :propsRows="rowsDlgCartHesab" :propsColumn="columnsDlgCartHesab" :hasRowNum="true" v-if="$store.state.renderComponentGrid"> </Bnp-Grid>
      </template>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import DetailUser from '@/components/BnpCash/SanadComponents/DetailUser.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'

export default {
  components: { Card, datePicker: VuePersianDatetimePicker, DetailUser, SearchableCombo, BnpGrid },
  data() {
    return {
      DataAxiosDlgCartHesab: {
        ArryfildValue: {},
      },
      DataAxoisColumns: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: 'frmDlgCartHesab',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      },
      rowsDlgCartHesab: [],
      columnsDlgCartHesab: [],
      DlgCartHesab: {
        Data: [
          {
            TarixSanadAz: '',
            TarixSanadTa: '',
            ShomareOzv: '',
            Vcode: '',
            TblGrpId: 1,
            TblDoreId: 1,
            TblDoreText: '1401',
          },
        ],
      },
    }
  },
  created() {
    this.DataAxiosDlgCartHesab.ArryfildValue = this.DlgCartHesab.Data[0]
    this.DataAxiosDlgCartHesab.ArryfildValue.TarixSanadTa = this.$store.state.JalaliDate
    this.DataAxiosDlgCartHesab.ArryfildValue.TarixSanadAz = this.PropTarixAz == false ? '' : this.$store.state.JalaliDate
  },
  methods: {
    Search() {
      try {
        this.DataAxiosDlgCartHesab.Action = 'DlgCartHesab'
        this.DataAxiosDlgCartHesab.Method = 'post'
        this.DataAxiosDlgCartHesab.ArryfildValue.TarixSanadTa = this.DataAxiosDlgCartHesab.ArryfildValue.TarixSanadTa == null ? '' : this.DataAxiosDlgCartHesab.ArryfildValue.TarixSanadTa
        this.DataAxiosDlgCartHesab.ArryfildValue.TarixSanadAz = this.DataAxiosDlgCartHesab.ArryfildValue.TarixSanadAz == null ? '' : this.DataAxiosDlgCartHesab.ArryfildValue.TarixSanadAz
        this.DataAxiosDlgCartHesab.ArryfildValue.TblGrpId = this.$session.get('UserInfo').tblGrpId
        this.$PostData(this.DataAxiosDlgCartHesab)
          .then((data) => {
            if (data.length > 0) {
              console.log(data)
              this.rowsDlgCartHesab = data
              for (let index = 0; index < this.rowsDlgCartHesab.length; index++) {
                this.rowsDlgCartHesab[index]['row'] = index + 1
              }
              this.$FormatMablaghGrid(this.rowsDlgCartHesab)
            } else {
              this.rowsDlgCartHesab = []
              this.$mySweetDefaultTost('عدم وجود اطلاعات', 'اطلاعاتی وجود ندارد ', 'info', 2000)
            }
          })
          .finally(() => {
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          })
      } catch (error) {
        console.error(error)
      }
    },
    GetGridColumns() {
      this.$GetColumns(this.DataAxoisColumns, true)
        .then((data) => {
          this.columnsDlgCartHesab = data
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    ValueResultDoreMali(val) {
      if (val.id == null) {
        this.DataAxiosDlgCartHesab.ArryfildValue.TblDoreId = 1
        this.DataAxiosDlgCartHesab.ArryfildValue.TblDoreText = ''
      } else {
        this.DataAxiosDlgCartHesab.ArryfildValue.TblDoreId = val.id == null ? 0 : val.id
        this.DataAxiosDlgCartHesab.ArryfildValue.TblDoreText = val.id == null ? 0 : val.id.Name
      }
    },
  },
  mounted() {
    this.DataAxiosDlgCartHesab.ArryfildValue = this.DlgCartHesab.Data[0]
    this.DataAxiosDlgCartHesab.ArryfildValue.ShomareOzv = this.AzaInfo.ShomareOzv
    this.DataAxiosDlgCartHesab.ArryfildValue.Vcode = this.Vcode
    this.GetGridColumns()
    this.Search()
  },
  beforeMount() {
    this.DataAxiosDlgCartHesab.ArryfildValue = this.DlgCartHesab.Data[0]
  },
  props: ['PropTarixAz', 'AzaInfo', 'Vcode'],
}
</script>
<style scoped></style>
